import React,{useState} from 'react';
import {FaPlay} from 'react-icons/fa';
import bg from '../images/modal.jpg';
import ModalVideo from 'react-modal-video';

const About  = () => {

    const [isOpen,setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);

    return (
        <div className="about">
            <div className="row">
                <div className="col-12 col-sm-6 col-md-6">
                    <div className="about_heading">
                       <h3>About us</h3> 
                       <div className="about_divider" />
                    </div>
                    <div className="about_content">
                        <p className="about_text">
                            Penetration testing emulates the real world threats and attacks you are 
                            likely to encounter. The goal of penetration testing is usually to identify
                            the weakness and demonstrate the impact before an attacker does. PowerScript
                             security therefore provides client tailored and compliance tailored testing packages
                              including GDPR, SOX, HIPAA, NIST, PCI-DSS and the CIS top 20.
                        </p>
                    </div>
                </div>
                <div className="col-12 col-sm-6 col-md-6">
                    <div className="about_modal" style={{backgroundImage:`url(${bg})`}}>
                        <div className="about_modal_overlay">
                            <div className="about_modal_content">
                                <FaPlay className="about_modal_icon" onClick={toggle}/>
                                <ModalVideo channel="youtube" isOpen={isOpen} onClose={toggle} videoId="lLessJ4R6w8"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default About;